import { render, staticRenderFns } from "./AssessmentRedirect.vue?vue&type=template&id=099daf23&scoped=true"
import script from "./AssessmentRedirect.vue?vue&type=script&lang=js"
export * from "./AssessmentRedirect.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRedirect.vue?vue&type=style&index=0&id=099daf23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099daf23",
  null
  
)

export default component.exports